<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	import axios from "axios";
	import router from "./router";
	import $ from "jquery";
	export default {
		name: "App",
		created() {
			axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
			axios.defaults.headers.get["Accepts"] = "application/json";
			axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
			axios.interceptors.response.use(
				function(response) {
					if (response.data.maintenance) {
						router.push("/global/maintenance");
					}
					return response;
				},
				function(error) {
					return Promise.reject(error);
				}
			);

			$(window).scroll(function() {
				if ($(this).scrollTop() > 50) {
					$(".scrolltop:hidden")
						.stop(true, true)
						.fadeIn();
				} else {
					$(".scrolltop")
						.stop(true, true)
						.fadeOut();
				}
			});
			axios.interceptors.response.use(undefined, function(err) {
				return new Promise(function(resolve, reject) {
					if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
						this.$store.dispatch("logout");
					}
					throw err;
				});
			});
		},
		watch: {
			$route(to, from) {
				setTimeout(() => {
					$(".pman").css("margin-top", "20px");
					$(".top_summary .container .row")
						.children()
						.first()
						.css("padding", "45px 0px");
					window.scrollTo(0, 0);
				}, 1);
			}
		}
	};
</script>
<style>
	/* You can add global styles to this file, and also import other style files */

	@font-face {
		font-family: "CocoGothic";
		src: url("./assets/fonts/coco-gothic.regular.ttf"); /* IE9 Compat Modes */
	}

	@font-face {
		font-family: "mplus2-m";
		src: url("./assets/fonts/mplus-2p-medium.ttf"); /* IE9 Compat Modes */
	}

	@font-face {
		font-family: "mplus2-r";
		src: url("./assets/fonts/mplus-2p-regular.ttf"); /* IE9 Compat Modes */
	}

	@font-face {
		font-family: "mplus1c";
		src: url("./assets/fonts/mplus-1c-light.ttf"); /* IE9 Compat Modes */
	}

	@font-face {
		font-family: "dincondensebold";
		src: url("./assets/fonts/din-condense-bold.ttf"); /* IE9 Compat Modes */
	}

	video:focus {
		outline: none;
	}
	.errorClass.invalid .multiselect__tags {
		border: 1px solid red !important;
		background-color: #ffc9aa !important;
	}
	.errorClass.invalid .multiselect__input {
		background-color: #ffc9aa !important;
	}
	.input.invalid .mx-input {
		border: 1px solid red;
		background-color: #ffc9aa;
	}
	.input.invalid .mx-input-append {
		background-color: #ffc9aa;
	}
	.textGra {
		color: gray;
	}
	/* tooltip */
	.tooltip.popover {
		display: block !important;
		z-index: 2;
		border-radius: 16px;
	}
	.tooltip .tooltip-inner {
		max-width: 460px;
		background: black;
		color: white;
		border-radius: 16px;
		padding: 5px 10px 4px;
	}
	.tooltip .tooltip-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: black;
		z-index: 1;
	}
	.tooltip.popover[x-placement^="top"] {
		margin-bottom: 5px;
	}
	.tooltip.popover[x-placement^="top"] .tooltip-arrow.popover-arrow {
		border-width: 5px 5px 0 5px;
		border-left-color: transparent !important;
		border-right-color: transparent !important;
		border-bottom-color: transparent !important;
		bottom: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0;
	}
	.tooltip.popover[x-placement^="bottom"] {
		margin-top: 5px;
	}
	.tooltip.popover[x-placement^="bottom"] .tooltip-arrow.popover-arrow {
		border-width: 0 5px 5px 5px;
		border-left-color: transparent !important;
		border-right-color: transparent !important;
		border-top-color: transparent !important;
		top: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0;
	}
	.tooltip.popover[x-placement^="right"] {
		margin-left: 5px;
	}
	.tooltip.popover[x-placement^="right"] .tooltip-arrow.popover-arrow {
		border-width: 5px 5px 5px 0;
		border-left-color: transparent !important;
		border-top-color: transparent !important;
		border-bottom-color: transparent !important;
		left: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0;
	}
	.tooltip.popover[x-placement^="left"] {
		margin-right: 5px;
	}
	.tooltip.popover[x-placement^="left"] .tooltip-arrow.popover-arrow {
		border-width: 5px 0 5px 5px;
		border-top-color: transparent !important;
		border-right-color: transparent !important;
		border-bottom-color: transparent !important;
		right: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0;
	}
	.tooltip.popover[aria-hidden="true"] {
		visibility: hidden;
		opacity: 0;
		transition: opacity 0.15s, visibility 0.15s;
	}
	.tooltip.popover[aria-hidden="false"] {
		visibility: visible;
		opacity: 1;
		transition: opacity 0.15s;
	}
	.tooltip.info .tooltip-inner {
		background: rgba(0, 68, 153, 0.9);
		color: white;
		padding: 24px;
		border-radius: 5px;
		box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
	}
	.tooltip.info .tooltip-arrow {
		border-color: rgba(0, 68, 153, 0.9);
	}
	.tooltip.popover .popover-inner {
		width: 460px;
		background: white;
		color: gray;
		border: 1px solid gray;
		border-radius: 16px;
		padding: 18px 0px 5px;
	}
	.tooltip.popover .popover-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: black;
		z-index: 1;
	}

	.tooltip.pop_up {
		display: block !important;
		z-index: 2;
		border-radius: 16px;
	}
	.tooltip .tooltip-inner {
		max-width: 460px;
		background: black;
		color: white;
		border-radius: 16px;
		padding: 5px 10px 4px;
	}
	.tooltip .tooltip-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: black;
		z-index: 1;
	}
	.tooltip.pop_up[x-placement^="top"] {
		margin-bottom: 5px;
	}
	.tooltip.pop_up[x-placement^="top"] .tooltip-arrow.popover-arrow {
		border-width: 5px 5px 0 5px;
		border-left-color: transparent !important;
		border-right-color: transparent !important;
		border-bottom-color: transparent !important;
		bottom: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0;
	}
	.tooltip.pop_up[x-placement^="bottom"] {
		margin-top: 5px;
	}
	.tooltip.pop_up[x-placement^="bottom"] .tooltip-arrow.popover-arrow {
		border-width: 0 5px 5px 5px;
		border-left-color: transparent !important;
		border-right-color: transparent !important;
		border-top-color: transparent !important;
		top: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0;
	}
	.tooltip.pop_up[x-placement^="right"] {
		margin-left: 5px;
	}
	.tooltip.pop_up[x-placement^="right"] .tooltip-arrow.popover-arrow {
		border-width: 5px 5px 5px 0;
		border-left-color: transparent !important;
		border-top-color: transparent !important;
		border-bottom-color: transparent !important;
		left: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0;
	}
	.tooltip.pop_up[x-placement^="left"] {
		margin-right: 5px;
	}
	.tooltip.pop_up[x-placement^="left"] .tooltip-arrow.popover-arrow {
		border-width: 5px 0 5px 5px;
		border-top-color: transparent !important;
		border-right-color: transparent !important;
		border-bottom-color: transparent !important;
		right: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0;
	}
	.tooltip.pop_up[aria-hidden="true"] {
		visibility: hidden;
		opacity: 0;
		transition: opacity 0.15s, visibility 0.15s;
	}
	.tooltip.pop_up[aria-hidden="false"] {
		visibility: visible;
		opacity: 1;
		transition: opacity 0.15s;
	}
	.tooltip.info .tooltip-inner {
		background: rgba(0, 68, 153, 0.9);
		color: white;
		padding: 24px;
		border-radius: 5px;
		box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
	}
	.tooltip.info .tooltip-arrow {
		border-color: rgba(0, 68, 153, 0.9);
	}
	.tooltip.pop_up .popover-inner {
		width: 460px;
		background: white;
		color: gray;
		border: 1px solid gray;
		border-radius: 16px;
		padding: 18px 0px 5px;
	}
	.tooltip.pop_up .popover-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: black;
		z-index: 1;
	}

	.engineerList .multiselect__content-wrapper {
		width: 285px !important;
	}
	.engineerList .multiselect {
		width: 245px !important;
	}
	.trial {
		background-color: #aaa !important;
		color: #fff;
		margin-left: 20px;
		border-radius: 0px;
	}
	.change {
		color: #fff;
		margin-left: 20px;
		border-radius: 0px;
	}
	.inquiry {
		margin-left: 20px;
		border-radius: 0px;
	}
	.swal2-popup .swal2-actions {
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		margin: 2.25em auto 0 !important;
	}
	.m-cropper-hide .cropper-modal {
		background-color: white;
	}
	.m-cropper-container .cropper-view-box {
		border-radius: 100%;
	}
	.m-cropper-container .cropper-crop-box {
		min-width: 147px !important;
		min-height: 147px !important;
	}
	.multi-select-custom:after {
		/* border-style: none !important;
	    content: none; */
		content: "\F0D7";
		font: normal normal normal 17px/1 FontAwesome;
		color: #3d7dd8;
		right: 11px;
		top: -3px;
		right: 15px;
		height: 34px;
		padding: 15px 0px 0px 8px;
		position: absolute;
		pointer-events: none;
		font-size: 20px;
	}
	.dincondensebold {
		font-family: dincondensebold;
	}

	.mplus2p-m {
		font-family: mplus2-m;
	}

	.mplus2p-r {
		font-family: mplus2-r;
	}

	.mplus1c {
		font-family: mplus1c;
	}

	.cocogothic {
		font-family: CocoGothic;
	}

	.navbar-toggler-icon-white {
		background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E") !important;
	}

	.navbar-toggler-icon-blue {
		background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgb(61, 125, 216, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E") !important;
	}

	.navbar-toggler-white {
		border: 1px solid white !important;
	}

	.navbar-toggler-blue {
		border: 1px solid #3d7dd8 !important;
	}

	.white {
		color: white !important;
	}

	.blue {
		color: #3d7dd8 !important;
	}

	.darkergray {
		color: #788ca0;
	}

	.gray {
		color: #b4bec8;
	}

	.black {
		color: #283c50;
	}

	.noiseblack {
		color: #3c5064;
	}

	.bluesky {
		color: #86ffee;
	}

	.red {
		color: red;
	}

	.green {
		color: rgb(4, 141, 100) !important;
	}

	.white_bg {
		background-color: white;
	}

	.blue_bg {
		background-color: #3d7dd8;
	}

	.dark_bg {
		background-color: #283c50;
	}

	.darkblue_bg {
		background-color: #4168af;
	}

	.littlewhiteblue_bg {
		background-color: #2296dd;
	}

	.morewhiteblue_bg {
		background-color: #19a6dc;
	}

	.mx-input {
		height: 44px !important;
	}
	.mx-input.form-control:disabled,
	.form-control[readonly] {
		background-color: #ffffff;
		opacity: 1;
	}

	.skywhitebtn {
		background-color: rgba(61, 125, 216, 0.16);
		color: #3d7dd8;
	}

	.darkbluebtn {
		background-color: #354d94;
		color: white;
		border-radius: 6.4px;
		font-weight: bold;
	}
	.darkbluebtn:hover {
		background-color: #4662b4;
		color: white;
	}

	.bluebtn {
		background-color: #3d7dd8;
		color: white;
		border-radius: 6.4px;
		font-weight: bold;
	}
	.bluebtn:hover {
		background-color: #306fc7;
		color: white;
	}
	.h_bluebtn {
		background-color: #3d7dd8;
		color: white;
		border-radius: 4px;
		font-weight: bold;
	}
	.h_bluebtn:hover {
		background-color: white;
		color: #3d7dd8;
		border-color: #3d7dd8;
	}

	.whitebtn {
		background-color: white;
		color: #3d7dd8;
		border-radius: 4px;
		font-weight: bold;
	}
	.whitebtn:hover {
		background-color: #3d7dd8;
		color: white;
	}
	.whitebtn2 {
		background-color: white;
		color: #6699cc;
		border-radius: 4px;
		font-weight: bold;
		border: 2px solid #6699cc;
	}
	.whitebtn2:hover {
		background-color: #6699cc;
		color: white;
	}

	.corporationbtn {
		width: 300px;
		height: 50px;
		background-color: white;
		color: #3d7dd8;
		border-radius: 4px;
		margin-top: 30px;
		font-weight: bold;
	}
	.corporationbtn:hover {
		background-color: #3d7dd8;
		color: white;
		border: solid 1px white;
	}

	.nav-link {
		margin-right: 20px;
	}

	#footer1 {
		text-align: right;
	}
	#footer2 {
		text-align: center;
	}
	#footer3 {
		text-align: left;
	}

	.myfixed_nav {
		background-color: white;
		box-shadow: 0 4px 2px -2px gray;
	}

	.spacing5-9 {
		letter-spacing: 5.9px;
	}

	.spacing5-5 {
		letter-spacing: 5.5px;
	}

	.spacing4 {
		letter-spacing: 4px;
	}

	.spacing3-4 {
		letter-spacing: 3.4px;
	}

	.spacing3-2 {
		letter-spacing: 3.2px;
	}

	.spacing2-8 {
		letter-spacing: 2.8px;
	}

	.spacing2-4 {
		letter-spacing: 2.4px;
	}

	.spacing2-1 {
		letter-spacing: 2.1px;
	}

	.spacing2 {
		letter-spacing: 2px;
	}

	.spacing1 {
		letter-spacing: 1px;
	}

	.spacing1-2 {
		letter-spacing: 1.2px;
	}

	.spacing1-4 {
		letter-spacing: 1.4px;
	}

	.spacing1-6 {
		letter-spacing: 1.6px;
	}

	.spacing0-7 {
		letter-spacing: 0.7px;
	}

	.spacing0-5 {
		letter-spacing: 0.5px;
	}

	.spacing0-4 {
		letter-spacing: 0.4px;
	}

	.footer_clink {
		font-weight: bold;
		font-size: 12px;
	}

	.dropdown-content {
		display: none;
		position: absolute;
		background-color: white;
		min-width: 160px;
		overflow: auto;
		box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
		z-index: 1;

		top: 60px;
		right: 15px;
	}

	.dropitem {
		color: #3d7dd8 !important;
		padding: 12px 16px;
		text-decoration: none;
		display: block;
		cursor: pointer;
	}

	.dropitem:hover {
		color: white !important;
		background-color: #3d7dd8;
	}

	.ddactive {
		color: white !important;
		background-color: #3d7dd8;
	}

	.show {
		display: block;
	}
	.hider {
		display: none;
	}

	#languagebtn {
		cursor: pointer;
		margin-left: 30px;
	}

	.realbody {
		margin-top: 60px;
		margin-bottom: 80px;
	}

	.mgtop10 {
		margin-top: 10px;
	}

	.s_panel_title {
		font-size: 2rem;
		font-weight: 500;
	}

	.r_panel_title {
		font-size: 1.5rem;
		font-weight: 500;
	}

	.help-block {
		color: red;
	}

	/*select part*/
	.selectdiv {
		position: relative;
		/*Don't really need this just for demo styling*/
	}

	.selectdiv:after {
		content: "\f0d7";
		font: normal normal normal 17px/1 FontAwesome;
		color: #3d7dd8;
		right: 11px;
		top: 6px;
		height: 34px;
		padding: 15px 0px 0px 8px;
		position: absolute;
		pointer-events: none;
		font-size: 20px;
	}

	/* IE11 hide native button (thanks Matt!) */
	select::-ms-expand {
		display: none;
	}

	.selectdiv select {
		-webkit-appearance: none;
		-moz-appearance: none;
		display: block;
		width: 100%;
		height: 50px;
		float: right;
		margin: 5px 0px;
		padding: 0px 14px;
		font-size: 16px;
		line-height: 1.75;
		color: #333;
		background-color: #ffffff;
		background-image: none;
		border: 1px solid #b4bec8;
		border-radius: 4px;
		-ms-word-break: normal;
		word-break: normal;
	}
	/*select part*/

	/*select part*/
	.selectrounddiv {
		position: relative;
		/*Don't really need this just for demo styling*/
	}

	.selectrounddiv:after {
		content: "\f107 ";
		font: normal normal normal 17px/1 FontAwesome;
		color: #000000;
		background-color: rgba(48, 56, 64, 0.04);
		border-radius: 10px;
		width: 20px;
		height: 30px;
		right: 10px;
		top: 14px;
		height: 21px;
		padding: 3px 0px 0px 5.5px;
		position: absolute;
		pointer-events: none;
		font-size: 15px;
	}

	/* IE11 hide native button (thanks Matt!) */
	select::-ms-expand {
		display: none;
	}

	.selectrounddiv select {
		-webkit-appearance: none;
		-moz-appearance: none;
		display: block;
		width: 100%;
		height: 50px;
		float: right;
		margin: 5px 0px;
		padding: 0px 14px;
		font-size: 16px;
		line-height: 1.75;
		color: #333;
		background-color: #ffffff;
		background-image: none;
		border: 1px solid #b4bec8;
		border-radius: 4px;
		-ms-word-break: normal;
		word-break: normal;
	}
	/*select part*/

	.top_summary {
		background-color: #f8fafa;
		/* max-height: 225px; */
	}

	.top_summary_header {
		font-size: 2.5rem;
		font-weight: 500;
		margin-bottom: 11px;
	}
	.top_summary_comment {
		font-size: 0.875rem;
	}

	.mmtopone {
		margin-bottom: 25px;
	}
	.mmenu_headers {
		font-size: 1rem;
		font-weight: 500;
		margin-top: 24px;
		margin-bottom: 12px;
	}
	.mmenu_item {
		width: 100%;
		height: 44px;
		border-radius: 4px;
		padding: 13px 7px;
		background-color: white;
		border: solid 1px #e6e8ea;
		margin-top: 8px;
		cursor: pointer;
	}
	.mmenu_item:hover,
	.mmichosen {
		background-color: rgba(61, 125, 216, 0.24);
		border: solid 1px #e6e8ea;
	}
	.mmenu_item_txt {
		font-size: 0.8125rem;
		font-weight: 500;
		float: left;
		color: #3c5064;
	}
	.mmenu_item_arrow {
		font-size: 1.5rem;
		color: gray;
		float: right;
		margin-top: -10px;
	}
	.mmenu_item:hover .mmenu_item_txt,
	.mmichosen .mmenu_item_txt {
		color: #3d7dd8;
	}
	.mmenu_item:hover .mmenu_item_arrow,
	.mmichosen .mmenu_item_arrow {
		color: #3d7dd8;
	}
	.mmenu_item_badge {
		font-size: 0.8125rem;
		font-weight: 500;
		float: right;
		margin-right: 25px;
		color: #3c5064;
	}
	.mbadge_num {
		color: #3d7dd8;
	}
	.mmenu_item:hover .mbadge_num,
	.mmenu_item:hover .mmenu_item_badge,
	.mmichosen .mbadge_num,
	.mmichosen .mmenu_item_badge {
		color: #3d7dd8;
	}

	.page_title {
		height: 40px;
		border-radius: 2px;
		border-left: solid 4px #3d7dd8;
		margin-top: 10px;
		padding: 7px;
		padding-left: 12px;
	}
	.page_title_comment {
		font-size: 1.125rem;
		font-weight: 500;
	}

	.peditboxes {
		border-radius: 3.2px;
	}

	.styled-checkbox {
		position: absolute;
		opacity: 0;
	}
	.styled-checkbox + label {
		position: relative;
		cursor: pointer;
		padding: 0;
	}
	.styled-checkbox + label:before {
		content: "";
		margin-right: 10px;
		display: inline-block;
		vertical-align: text-top;
		width: 16px;
		height: 16px;

		border-radius: 2px;
		background-color: #f0f2f4;
		border: solid 1px #e6e8ea;
	}
	.styled-checkbox:hover + label:before {
		background: #3d7dd8;
	}
	.styled-checkbox:focus + label:before {
		box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
	}
	.styled-checkbox:checked + label:before {
		background: #3d7dd8;
	}
	.styled-checkbox:disabled + label {
		color: #b8b8b8;
		cursor: auto;
	}
	.styled-checkbox:disabled + label:before {
		box-shadow: none;
		background: #ddd;
	}
	.styled-checkbox:checked + label:after {
		content: "";
		position: absolute;
		left: 3px;
		top: 9px;
		background: white;
		width: 2px;
		height: 2px;
		box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white,
			4px -6px 0 white, 4px -8px 0 white;
		transform: rotate(45deg);
	}
	.unstyled {
		margin: 0;
		padding: 0;
		list-style-type: none;
	}

	.ceboxes {
		border-radius: 4px;
		box-shadow: 0 1px 4px 0 rgba(60, 80, 100, 0.12);
		background-color: #ffffff;
		border: solid 1px #e8eaee;
		padding: 14px 16px;
	}

	.skillitem {
		height: 20px;
		border-radius: 3.2px;
		background-color: rgba(61, 125, 216, 0.08);
		color: #3d7dd8;
		font-size: 0.625rem;
		font-weight: 500;
		padding: 4px 8px;
		margin-left: 5px;
		float: left;
		margin-top: 6px;
		cursor: pointer;
	}

	.skillitem:hover {
		background-color: rgba(61, 125, 216, 0.17);
	}

	@media screen and (max-width: 1748px) {
		.paddings {
			padding: 0px 80px;
		}
	}

	@media screen and (max-width: 1200px) {
		.paddings {
			padding: 0px 80px;
		}
	}

	@media screen and (max-width: 1137px) {
		#languagebtn {
			margin-left: 0px;
		}
	}

	@media screen and (max-width: 1107px) {
	}

	@media screen and (max-width: 1079px) {
	}

	@media screen and (max-width: 992px) {
		.paddings {
			padding: 0px 0px;
		}

		.dropdown-content {
			position: relative;
			top: 80px;
		}

		#languagebtn {
			margin-left: 0px;
			margin-top: 0px;
		}

		.mmenu_item {
			height: 75px;
		}
	}

	@media screen and (max-width: 905px) {
	}

	@media screen and (max-width: 768px) {
		#footer1 {
			text-align: center;
		}
		#footer2 {
			text-align: center;
		}
		#footer3 {
			text-align: center;
		}
		.mmenu_item {
			height: 44px;
		}
	}

	@media screen and (max-width: 600px) {
	}

	@media screen and (max-width: 480px) {
	}

	@media screen and (max-width: 450px) {
	}

	@media screen and (max-width: 372px) {
		.dropdown-content {
			position: relative;
		}
	}

	@media screen and (max-width: 320px) {
		.dropdown-content {
			position: relative;
		}
	}

	@media screen and (max-width: 250px) {
		.dropdown-content {
			position: relative;
			top: 20px;
			right: 0px;
		}
	}

	/*scrolltop*/
	.scrolltop {
		display: none;
		width: 100%;
		margin: 0 auto;
		position: fixed;
		bottom: 20px;
		right: 10px;
	}
	.scroll {
		position: absolute;
		right: 20px;
		bottom: 20px;
		background: #3d7dd8;
		text-align: center;
		margin: 0 0 0 0;
		cursor: pointer;
		transition: 0.5s;
		-moz-transition: 0.5s;
		-webkit-transition: 0.5s;
		-o-transition: 0.5s;

		border-radius: 50px;
		height: 50px;
		width: 50px;
		padding-top: 13px;
		color: white;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
	}
	.scroll:hover {
		background: white;
		color: #3d7dd8;
		transition: 0.5s;
		-moz-transition: 0.5s;
		-webkit-transition: 0.5s;
		-o-transition: 0.5s;
	}
	.scroll:hover .fa {
		padding-top: -10px;
	}
	.scroll .fa {
		font-size: 30px;
		margin-top: -5px;
		margin-left: 1px;
		transition: 0.5s;
		-moz-transition: 0.5s;
		-webkit-transition: 0.5s;
		-o-transition: 0.5s;
	}

	/* Absolute Center Spinner */
	.mainLoader {
		position: fixed;
		z-index: 999;
		height: 2em;
		width: 2em;
		overflow: show;
		margin: auto;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}

	/* Transparent Overlay */
	.mainLoader:before {
		content: "";
		display: block;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.3);
	}

	/* :not(:required) hides these rules from IE9 and below */
	.mainLoader:not(:required) {
		/* hide "loading..." text */
		font: 0/0 a;
		color: transparent;
		text-shadow: none;
		background-color: transparent;
		border: 0;
	}

	.mainLoader:not(:required):after {
		content: "";
		display: block;
		font-size: 30px;
		width: 1em;
		height: 1em;
		margin-top: -0.5em;
		-webkit-animation: spinner 1500ms infinite linear;
		-moz-animation: spinner 1500ms infinite linear;
		-ms-animation: spinner 1500ms infinite linear;
		-o-animation: spinner 1500ms infinite linear;
		animation: spinner 1500ms infinite linear;
		border-radius: 0.5em;
		-webkit-box-shadow: rgba(253, 0, 0, 0.75) 1.5em 0 0 0,
			rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
			rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
			rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
			rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
		box-shadow: rgba(2, 133, 255, 0.75) 1.5em 0 0 0,
			rgba(101, 186, 255, 0.75) 1.1em 1.1em 0 0, rgba(2, 133, 255, 0.75) 0 1.5em 0 0,
			rgba(101, 186, 255, 0.75) -1.1em 1.1em 0 0,
			rgba(2, 133, 255, 0.75) -1.5em 0 0 0,
			rgba(101, 186, 255, 0.75) -1.1em -1.1em 0 0,
			rgba(2, 133, 255, 0.75) 0 -1.5em 0 0,
			rgba(101, 186, 255, 0.75) 1.1em -1.1em 0 0;
	}

	/* Animation */

	@-webkit-keyframes spinner {
		0% {
			-webkit-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@-moz-keyframes spinner {
		0% {
			-webkit-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@-o-keyframes spinner {
		0% {
			-webkit-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@keyframes spinner {
		0% {
			-webkit-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	.multiselect__tag {
		background: #3d7dd8 !important;
	}

	.multiselect__tag-icon:focus,
	.multiselect__tag-icon:hover {
		/* background: #369a6e */
		background: #3d7dd8 !important;
	}
	.multiselect__option--highlight {
		/* background: #41b883; */
		background: #3d7dd8 !important;
		outline: none;
		color: #fff;
	}
	.multiselect__option--selected.multiselect__option--highlight {
		background: #ff6a6a !important;
		color: #fff;
	}
	.multiselect__option--selected.multiselect__option--highlight:after {
		background: #ff6a6a !important;
		color: #fff;
	}

	.multiselect__tag-icon:after {
		content: "\D7";
		color: #fff;
		font-size: 14px;
	}
	multiselect__option {
		background: #3d7dd8 !important;
	}
	.multiselect__option--highlight:after {
		content: attr(data-select);
		/* background: #41b883; */
		background: #3d7dd8 !important;
		color: #fff;
	}
	.multiselect__spinner:after,
	.multiselect__spinner:before {
		position: absolute;
		content: "";
		top: 50%;
		left: 50%;
		margin: -8px 0 0 -8px;
		width: 16px;
		height: 16px;
		border-radius: 100%;
		border-color: #3d7dd8 transparent transparent !important;
		border-style: solid;
		border-width: 2px;
		box-shadow: 0 0 0 1px transparent;
	}

	.pfdListing .VuePagination{
  		justify-content: flex-end;
		  padding-right: 0px;
		  margin-left: 0px;
	}
	.custom-file-upload-pdf {
		background-color: DodgerBlue !important;
		border: none;
		border-radius: 6.4px !important; 
		color: white;
		padding: 12px 16px !important;
		font-size: 16px;
		cursor: pointer;
	}

	/* Darker background on mouse-over */
	.custom-file-upload-pdf:hover {
	background-color: RoyalBlue;
	}
	.VueTables__row .number,.action{
		text-align: center;
	}

	.VueTables__row .upload_date div{
		color: black !important;
	}
</style>
